import API from 'services/api.js';
import { URL_YARD_WT_FILES } from 'services/urls.js';

export type YardWeightRecord = {
	breed?: string;
	sex?: string;
	wbw: number;
	eid?: string;
	vid?: string;
	effectiveDate: Date;
};

export type YardWeightFile = {
	key?: string;
	downloadUrl: string;
	size?: number;
	lastModified?: Date;
	etag?: string;
	clientId?: number;
	sessionId?: number;
	clientName?: string;
	sessionEmail?: string;
	parseSummary: {
		records: number;
		startDate?: Date;
		endDate?: Date;
	};
	parsePreview?: {
		first3: YardWeightRecord[];
		last3: YardWeightRecord[];
	};
};

export const actionFetchYardWeightFileList = async (): Promise<
	YardWeightFile[]
> => {
	return API.get(URL_YARD_WT_FILES)
		.then((response) => {
			console.log('response actionFetchYardWeightFileList()', response);
			return response.data;
		})
		.catch((error) => {
			console.error(error);
			throw new Error(
				`[${new Date()}] Error fetching yard weight file list: ${error}`
			);
		});
};

export const actionArchiveYardWeightFile = async (
	fileInfo: YardWeightFile
): Promise<{ message: string; archivePath: string }> => {
	const fileKey = fileInfo.key;
	console.log(`running actionArchiveYardWeightFile for filekey ${fileKey}`);

	const body = {
		action: 'archive',
		key: fileKey,
	};

	return API.post(URL_YARD_WT_FILES, body)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			console.error(error);
			if (error.response) {
				throw Error(
					`File archive failed with response code ${error.response.status}: ${fileKey}`
				);
			} else if (error.request) {
				throw Error(
					`File archive failed with no response from server: ${fileKey}`
				);
			} else {
				throw Error(`File archive could not be actioned: ${fileKey}`);
			}
		});
};

export const actionCommitYardWeightFile = async (fileInfo: YardWeightFile) => {
	const fileKey = fileInfo.key;
	console.log(`running actionCommitYardWeightFile for filekey ${fileKey}`);

	const body = {
		action: 'insert',
		key: fileKey,
	};

	return API.post(URL_YARD_WT_FILES, body)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			console.error(error);
			if (error.response) {
				throw Error(
					`File commit failed with response code ${error.response.status}: ${fileKey}`
				);
			} else if (error.request) {
				throw Error(
					`File commit failed with no response from server: ${fileKey}`
				);
			} else {
				throw Error(`File commit could not be actioned: ${fileKey}`);
			}
		})
		.then((responseData) => {
			return responseData;
		});
};
